export default __webpack_public_path__ + "static/media/DSC80006.481739cb.jpg";